import { Directive, ElementRef, OnInit, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appPadding]'
})
export class PaddingDirective implements OnInit {
    @Input() deepValue: number;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) { }

    ngOnInit(): void {
        this.setPadding(this.deepValue);
    }

    private setPadding(deep: number): void {
        this.renderer.setStyle(this.el.nativeElement, 'padding-left', `${10 + ((deep - 1) * 20)}px`);
        // this.el.nativeElement.style.paddingLeft = 10 + ((deep - 1) * 20) + 'px';
    }

}
